import { messageBus } from 'core/modules/message-bus';
import { GOOGLE_MAP_FOCUS_LOCATION } from 'constants/message-bus-events';

/**
 * @desc Focus a location marker in the map and open info window
 * @param {*} mapId - unique map id provided to map instance using `id` prop
 * @param {*} locationId - id of the location
 * @example
 * import { focusLocation } from 'modules/googleMap';
 * focusLocation( 'map_id', 'location_id' );
 */
export const focusLocation = ( mapId, locationId ) => {
    messageBus.trigger( `${ GOOGLE_MAP_FOCUS_LOCATION }__${ mapId }`, { id: locationId } );
};
